import React from 'react';
import { Row, Col } from 'antd';
import FeedbackForm from '../../form/feedback/FeedbackForm';
import solutionForBusiness from '../../assets/images/relyon_us.png';
import SEO from '../../components/SEO';
const RequestACallBack = () => {
    return (
        <div className="requestCallbackContainer">
            <SEO title="Feedback" description="One-Stop Transport & Finicial Solution" path="feedback" />
            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h2 className="blockTitle">Please tell us about your experience.</h2>
                    <FeedbackForm />
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 9, offset: 2 }}
                    xl={{ span: 9, offset: 2 }}
                    xxl={{ span: 9, offset: 2 }}
                >
                    <h1>Customer Satisfication Survey</h1>
                    <p className="paragraph">
                        Thank you for giving us the opportunity to serve you better. Please help us by taking a minute
                        or two to tell us about the service that you have received so far. We appreciate your business
                        and want to make sure we meet your expectations.{' '}
                    </p>
                    <img className="requestCallbackImg" src={solutionForBusiness} alt="be different" />
                </Col>
            </Row>
        </div>
    );
};

export default RequestACallBack;
